import { defineComponent, openBlock, createElementBlock } from "vue";
const _hoisted_1 = {
  src: "https://www.rei.com/dam/21698249_cb-pillars-lockup.svg",
  alt: "List of certifications which include The Climate Label certification,\n        member informed certification and 100% satisfaction guarantee"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CoopBrandCertifications",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("img", _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=CoopBrandCertifications.mjs.map
